import React from 'react';
import styled from 'styled-components';

const Selector = styled.select`
  margin-bottom: 1rem;
  padding: 0.5rem;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 1rem;
`;

const FontSelector = ({ value, onChange }) => {
  return (
    <div>
      <label htmlFor="font-select">انتخاب فونت:</label>
      <Selector id="font-select" value={value} onChange={(e) => onChange(e.target.value)}>
        <option value="Vazir">Vazir</option>
        <option value="Inter">Inter</option>
        <option value="Great Vibes">Great Vibes (تزئینی)</option>
      </Selector>
    </div>
  );
};

export default FontSelector;
